import { Component, OnInit } from "@angular/core";
import {BASK_URL_CHECK} from "../../constants";
import {SettingsEnum} from "../../model/settings.enum";
import {FacadeService} from "../../service-facade/facade.service";

@Component({
  selector: "app-invitation-error",
  templateUrl: "./invitation-error.component.html",
  styleUrls: ["./invitation-error.component.scss"]
})
export class InvitationErrorComponent implements OnInit{
  title = "";
  cancelURL = "";
  constructor(private facade: FacadeService) {}

  ngOnInit() {
    this.title = "This application is no longer valid.";
    this.cancelURL = this.facade.getStorageItem(location.href.includes(BASK_URL_CHECK)? SettingsEnum.DefaultBaskCancelUrl : SettingsEnum.DefaultCancelUrl);
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }
}
